export default __webpack_public_path__ + "static/media/OMSC_01.450a2efc.gif";